import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";

var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;

  return _c('main', {
    staticClass: "main page_studyResult_detail"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "title--page"
  }, [_vm._v(" " + _vm._s(_setup.student && _setup.student.name) + " さんの欠席履歴/学習履歴 ")]), _c('div', {
    staticClass: "button_wrap"
  }, [_c('div', {
    staticClass: "switch_button"
  }, [_c('router-link', {
    staticClass: "item switch_button__left",
    attrs: {
      "to": {
        name: 'attendances.detail',
        query: {
          student_id: _setup.student.id
        }
      },
      "aria-current": "page"
    }
  }, [_vm._v(" 欠席履歴 ")]), _c('router-link', {
    staticClass: "item switch_button__center active",
    attrs: {
      "to": {
        name: 'dekitus.detail',
        query: {
          student_id: _setup.student.id
        }
      }
    }
  }, [_vm._v(" 学習履歴 ")]), _c('router-link', {
    staticClass: "item switch_button__right",
    attrs: {
      "to": {
        name: 'attendances.monthly',
        query: {
          classroom_id: _setup.student.class_id
        }
      }
    }
  }, [_vm._v(" カレンダー ")])], 1)])]), _setup.isLoading ? _c('loading-message') : _vm._e(), _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "pagination__prev",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _setup.monthChange('sub');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })]), _c('div', {
    staticClass: "pagination__display"
  }, [_c('p', {
    staticClass: "pagination__month"
  }, [_vm._v(" " + _vm._s(_setup.localYearMonth) + " ")])]), _c('button', {
    staticClass: "pagination__next",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _setup.monthChange('add');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])]), _c('div', {
    attrs: {
      "id": "targetFrame"
    }
  }, [_c('h2', [_vm._v("授業履歴")]), _setup.lessonResults.length > 0 ? _c('div', {
    staticClass: "item-table"
  }, [_c('p', {
    staticClass: "summary"
  }, [_vm._v("総学習時間 " + _vm._s(_setup.monthlyLessonSummary))]), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l(_setup.lessonResults, function (studyResult, index) {
    return _c('tr', {
      key: index,
      staticClass: "table__tr"
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v(_vm._s(studyResult.start_date))]), _c('td', [_vm._v(" " + _vm._s(studyResult.time) + " ")]), _c('td', [_vm._v(" " + _vm._s(studyResult.start_time ? studyResult.start_time.slice(0, 5) : "") + " ～ " + _vm._s(studyResult.end_time ? studyResult.end_time.slice(0, 5) : "") + " ")]), _c('td', [_vm._v(" " + _vm._s(studyResult.school_year) + " ")]), _c('td', [_vm._v(" " + _vm._s(studyResult.subject) + " ")]), _c('td', {}, [_vm._v(_vm._s(studyResult.textbook_index))]), _c('td', {}, [_vm._v(" " + _vm._s(studyResult.jugyo) + " ")])]);
  }), 0)])]) : _c('div', {
    staticClass: "notfound"
  }, [_vm._v("授業履歴が見つかりませんでした。")]), _c('h2', [_vm._v("問題履歴")]), _setup.drillResults.length > 0 ? _c('div', {
    staticClass: "item-table"
  }, [_c('p', {
    staticClass: "summary"
  }, [_vm._v("総学習時間 " + _vm._s(_setup.monthlyDrillSummary))]), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _c('tbody', _vm._l(_setup.drillResults, function (studyResult, index) {
    return _c('tr', {
      key: index,
      staticClass: "table__tr"
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v(_vm._s(studyResult.start_date))]), _c('td', [_vm._v(" " + _vm._s(studyResult.time) + " ")]), _c('td', [_vm._v(" " + _vm._s(studyResult.start_time ? studyResult.start_time.slice(0, 5) : "") + " ～ " + _vm._s(studyResult.end_time ? studyResult.end_time.slice(0, 5) : "") + " ")]), _c('td', [_vm._v(" " + _vm._s(studyResult.school_year) + " ")]), _c('td', [_vm._v(" " + _vm._s(studyResult.subject) + " ")]), _c('td', {}, [_vm._v(_vm._s(studyResult.textbook_index))]), _c('td', {}, [_vm._v(" " + _vm._s(studyResult.type) + " ")]), _c('td', {}, [_vm._v(" " + _vm._s(studyResult.sum) + " ")])]);
  }), 0)])]) : _c('div', {
    staticClass: "notfound"
  }, [_vm._v("問題履歴が見つかりませんでした。")])])], 1);
};

var staticRenderFns = [function () {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;

  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col_2"
  }, [_vm._v("日付")]), _c('th', {
    staticClass: "col_1"
  }, [_vm._v("学習時間")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("時間帯")]), _c('th', {
    staticClass: "col_1"
  }, [_vm._v("学年")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("科目")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("単元")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("授業")])])]);
}, function () {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;

  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col_2"
  }, [_vm._v("日付")]), _c('th', {
    staticClass: "col_1"
  }, [_vm._v("学習時間")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("時間帯")]), _c('th', {
    staticClass: "col_1"
  }, [_vm._v("学年")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("科目")]), _c('th', {
    staticClass: "col_2"
  }, [_vm._v("単元")]), _c('th', {
    staticClass: "col_1"
  }, [_vm._v("タイプ")]), _c('th', {
    staticClass: "col_1"
  }, [_vm._v("スコア")])])]);
}];
export { render, staticRenderFns };